var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-text',[_c('small',[_vm._v(" "+_vm._s(_vm.cart.qty)+" x $"+_vm._s(_vm.cart.Product.price)+" : "+_vm._s(_vm.cart.Product.name)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }